import { theme } from '../theme';

export function Loader({ label = 'Загружаю…' }: { label?: string }) {
  return (
    <div
      style={{
        minHeight: '60vh',
        display: 'grid',
        placeItems: 'center',
        gap: 16,
        color: theme.colors.sub,
        fontFamily: theme.font,
      }}
    >
      <div
        style={{
          width: 36,
          height: 36,
          border: `3px solid ${theme.colors.line}`,
          borderTopColor: theme.colors.accent,
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
        }}
      />
      <div>{label}</div>
      <style>{`@keyframes spin { to { transform: rotate(360deg) } }`}</style>
    </div>
  );
}

export function ErrorState({ message, onRetry }: { message: string; onRetry: () => void }) {
  return (
    <div
      style={{
        minHeight: '60vh',
        display: 'grid',
        placeItems: 'center',
        gap: 16,
        padding: 24,
        color: theme.colors.ink,
        fontFamily: theme.font,
        textAlign: 'center',
      }}
    >
      <div style={{ fontSize: 18 }}>Что-то пошло не так</div>
      <div style={{ color: theme.colors.sub, fontSize: 14 }}>{message}</div>
      <button
        onClick={onRetry}
        style={{
          padding: '10px 18px',
          borderRadius: theme.radius.md,
          background: theme.colors.ink,
          color: theme.colors.paper,
          border: 'none',
          fontFamily: theme.font,
          fontSize: 14,
          cursor: 'pointer',
        }}
      >
        Повторить
      </button>
    </div>
  );
}
